<template>
  <!--
        action: 上传图片的地址
        list-type：展示类型
        limit 上传个数限制
        auto-upload 选取文件后就上传 开启
        file-list 文件列表
        on-exceed  超出上传限制时的行为
        on-change 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
        before-upload 限制用户上传的图片格式和大小。 若返回 false 或者返回 Promise 且 reject，则停止上传
        before-upload 限制用户上传的图片格式和大小。 
        name: 图片上传后台需要的name
        headers: 请求头
        data：上传时附带的额外参数
        multiple
        硬编码：
        on-preview：点击文件列表中已上传的文件时的钩子
        name="importExcel" 必不可少
        -->
  <el-upload
    class="icon-upload"
    action="https://upload.qiniup.com"
    name="importExcel"
    :accept="accept"
    :show-file-list="false"
    :limit="limit"
    :data="qnData"
    :on-error="handleError"
    :on-success="handleSucces"
    :before-upload="handleBefore"
  >
    <el-button
      class="upbtn el-icon-plus"
      circle
    ></el-button>
  </el-upload>

</template>

<script>
export default {
  props: {},
  created() {},
  data() {
    return {
      accept: ".jpg,.jpeg,.png",
      limit: 100, //限制上传个数
      qnData: {
        token: "",
        key: "",
      },
    };
  },

  methods: {
    handleBefore(file) {
      //后缀名类型判断
      let FileExt = file.name.replace(/.+\./, "");

      if (["jpg", "jpeg", "png"].indexOf(FileExt.toLowerCase()) === -1) {
        this.$message({
          type: "warning",
          message: "请上传后缀名为jpg,jpeg,png的图片 !",
        });
        return false;
      }
      //文件大小判断
      if (file.size / 1024 > 400) {
        this.$message.error("上传文件大小必须小于400KB！");
        return false;
      }

      //获取token，文件上传
      return this.$axios
        .get("/file/getQiNiuAccessToken")
        .then((res) => {
          this.qnData.token = res.accessToken;
          this.qnData.key =
            new Date().getTime() +
            "." +
            file.name.split(".")[file.name.split(".").length - 1]; // 处理上传同名文件失败加上时间戳
        })
        .catch(() => {
          this.$message({ type: "error", message: "网络错误请稍后重试" });
        });
    },
    //上传成功
    handleSucces(response) {
      if (response.resultCode === 200) {
        this.$message({ type: "success", message: response.data });
        this.$emit("uploadSucess")
      } else {
        this.$message({
          type: "error",
          message: response.msg || "上传失败，请稍后重试。",
        });
      }
    },
    //失败
    handleError() {
      this.$message.warning("上传失败请稍后重试！");
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.icon-upload {
  display: inline-block;
  .upbtn {
    border: 1px dashed #d3d0d0;
    width: 76px;
    height: 76px;
    font-size: 30px;
    margin: 5px;
  }
}
</style>
